import axiosInstance from "./axiosInstance";

const ProjectService = {
  getProjects: () => axiosInstance.get("/api/projects/"),

  createProject: async (data) => {
    const payload = {
      title: data.title || "",
      progress: data.progress || 0,
      status: data.status || "",
      order: data.order || 0,
      language: data.language || "Marathi",
    };
    console.debug("ProjectService.createProject:", payload);
    return axiosInstance.post("/api/projects/", payload);
  },

  updateProject: async (id, data) => {
    const payload = {
      title: data.title || "",
      progress: data.progress || 0,
      status: data.status || "",
      order: data.order || 0,
      language: data.language || "Marathi",
    };
    console.debug("ProjectService.updateProject:", payload);
    return axiosInstance.patch(`/api/projects/${id}/`, payload);
  },

  deleteProject: (id) => axiosInstance.delete(`/api/projects/${id}/`),
};

export default ProjectService;
